import {WithChildren} from '_metronic/helpers'
import {FC} from 'react'

type Props = {
  title: string
  actionComponent: React.ReactNode
  bodyMaxHeight?: string
}

const Card: FC<Props & WithChildren> = ({title, actionComponent, children, bodyMaxHeight}) => {
  return (
    // <div
    //   className='h-100 bg-white d-flex flex-column gap-6 p-6'
    //   style={{border: '1px solid #E5E7EB', borderRadius: '12px'}}
    // >
    //   <div className='d-flex align-items-center justify-content-between'>
    //     <h3 className='text-gray-900 mb-0' style={{fontSize: '18px', fontWeight: '600'}}>
    //       {title}
    //     </h3>
    //     <div>{actionComponent}</div>
    //   </div>

    //   <div className='h-100' style={{maxHeight: `${bodyMaxHeight ?? '50vh'}`, overflowY: 'auto',paddingRight:'4px'}}>
    //     {children}
    //   </div>
    // </div>
    <div className='card h-100'>
      <div className='card-header border-0 min-h-auto pt-5'>
        <div className='w-100 d-flex align-items-center justify-content-between'>
          <h3 className='text-dark fs-3 fw-bold mb-0'>{title}</h3>
          <div>{actionComponent}</div>
        </div>
      </div>

      <div
        className='card-body h-100'
        style={{maxHeight: `${bodyMaxHeight ?? '55vh'}`, overflowY: 'auto'}}
      >
        {children}
      </div>
    </div>
  )
}

export default Card
